// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"297":"8412e178","453":"f9060c5b","576":"923c81eb","577":"11f6b93c","585":"70b55bf9","716":"e3520ac1","847":"bf73bd72"}[chunkId] + ".chunk.js";
};